import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment } from 'react';
import { useMatchMediaQuery } from './useMatchMediaQuery';
/**
 * Standalone component for matching a media query
 *
 * Renders its children if the query matches
 * @param props
 * @returns
 * @example <MatchMediaQuery query={"(min-width: 600px"} />
 */
export function MatchMediaQuery(props) {
    var isVisible = useMatchMediaQuery(props.query);
    return isVisible ? _jsx(Fragment, { children: props.children }, void 0) : _jsx(Fragment, {}, void 0);
}
//# sourceMappingURL=MatchMediaQuery.js.map